import { render, staticRenderFns } from "./OrganizationUsersList.vue?vue&type=template&id=2d8b4308&"
import script from "./OrganizationUsersList.vue?vue&type=script&lang=js&"
export * from "./OrganizationUsersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports